import { render, staticRenderFns } from "./Recommendation.vue?vue&type=template&id=93143c46&scoped=true&"
import script from "./Recommendation.vue?vue&type=script&lang=js&"
export * from "./Recommendation.vue?vue&type=script&lang=js&"
import style0 from "./Recommendation.vue?vue&type=style&index=0&id=93143c46&prod&lang=scss&scoped=true&"
import style1 from "./Recommendation.vue?vue&type=style&index=1&id=93143c46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93143c46",
  null
  
)

export default component.exports